import React, { useRef } from 'react'
import HmprojectSlider from './HmprojectSlider'
import './Hmproject.css'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function Hmproject() {
  const headingRef = useRef(null)
  const sliderRef = useRef(null)

  useGSAP(() => {
    const headingEl = headingRef.current

    if (!headingEl) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      gsap.set(headingEl.children, { clearProps: 'all' })
      return
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: headingEl,
        start: 'top 50%',
        once: true
      }
    })

    tl.from(headingEl.querySelector('h5'), {
      autoAlpha: 0,
      y: 50,
      duration: 0.6,
      ease: 'power3.out'
    }).from(headingEl.querySelector('h3'), {
      autoAlpha: 0,
      y: 70,
      duration: 0.7,
      ease: 'power3.out'
    }, '-=0.2')
  }, { dependencies: [] })

  useGSAP(() => {
    const sliderEl = sliderRef.current

    if (!sliderEl) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      gsap.set(sliderEl, { clearProps: 'all' })
      return
    }

    const tween = gsap.from(sliderEl, {
      autoAlpha: 0,
      y: 80,
      duration: 0.8,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: sliderEl,
        start: 'top 50%',
        once: true
      }
    })

    return () => tween.kill()
  }, { dependencies: [] })

  return (
    <section className='hmproject-sec'>
        <div className='container'>
          <div className='mn-head' ref={headingRef}> 
            <h5>Our Projects</h5>
            <h3>Built for impact</h3>
           </div>
        </div>
        <div ref={sliderRef}>
          <HmprojectSlider />
        </div>

    </section>
  )
}

export default Hmproject
